import PublicNavbar from '../common/PublicNavbar'
import PublicFooter from '../common/PublicFooter'
import ChatwootWidget from '../common/Chatwoot'

export default function PublicTheme({ children, user_session }) {
    return (
        <div className='d-flex' style={{ minHeight: '100vh', flexDirection: 'column' }}>
            <PublicNavbar user_session={user_session} />
            <main className='flex-shrink-0 p-3 mt-5'>
                <ChatwootWidget />
                {children}
            </main>
            <PublicFooter />
        </div>
    )
}